import { useQuery } from '@tanstack/react-query'
import { SimpleGrid, Title, Stack, Loader, Alert, Text } from '@mantine/core'
import { appsApi } from '../../api/apps'
import AppCard from './AppCard'

export default function AppsList() {
  const {
    data: apps = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: ['apps', 'me'],
    queryFn: () => appsApi.listMine(),
  })

  if (isLoading) return <Loader />
  if (error) return <Alert color="red">Erro ao carregar apps: {String(error)}</Alert>
  if (apps.length === 0) {
    return <Text>Nenhuma app disponível para você.</Text>
  }

  return (
    <Stack>
      <Title order={2}>Minhas apps</Title>
      <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="md" data-testid="apps-grid">
        {apps.map((a) => (
          <AppCard key={a.slug} app={a} />
        ))}
      </SimpleGrid>
    </Stack>
  )
}
